import { MAX_COMPARE_CARS } from "@/components/car-listing/car-compare-context";

export const COMPARE_STORAGE_KEY = "autoplus_compare_v1";
export const COMPARE_URL_PARAM = "compare";

export function parseCompareIds(raw: string | null | undefined): number[] {
  if (!raw?.trim()) return [];
  const ids = raw
    .split(/[,،\s]+/)
    .map((s) => Number(s.trim()))
    .filter((n) => Number.isFinite(n) && n > 0);
  return [...new Set(ids)].slice(0, MAX_COMPARE_CARS);
}

export function encodeCompareIds(ids: number[]): string {
  return ids.slice(0, MAX_COMPARE_CARS).join(",");
}

export function loadStoredCompareIds(): number[] {
  try {
    const raw = localStorage.getItem(COMPARE_STORAGE_KEY);
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    if (!Array.isArray(parsed)) return [];
    return parsed
      .map((v) => Number(v))
      .filter((n) => Number.isFinite(n) && n > 0)
      .slice(0, MAX_COMPARE_CARS);
  } catch {
    return [];
  }
}

export function saveCompareIds(ids: number[]): void {
  try {
    if (!ids.length) {
      localStorage.removeItem(COMPARE_STORAGE_KEY);
      return;
    }
    localStorage.setItem(COMPARE_STORAGE_KEY, JSON.stringify(ids.slice(0, MAX_COMPARE_CARS)));
  } catch {
    /* quota */
  }
}

export function buildCompareShareUrl(ids: number[]): string {
  const base =
    typeof window !== "undefined"
      ? `${window.location.origin}/listings`
      : "https://www.autoplus.ps/listings";
  const params = new URLSearchParams();
  params.set(COMPARE_URL_PARAM, encodeCompareIds(ids));
  return `${base}?${params.toString()}`;
}

export function readCompareIdsFromSearch(search: string): number[] {
  const params = new URLSearchParams(search.startsWith("?") ? search.slice(1) : search);
  return parseCompareIds(params.get(COMPARE_URL_PARAM));
}
